import colors from "../base/colors";
import boxShadows from "../base/boxShadows";

import pxToRem from "../functions/pxToRem";

const { background, divider } = colors;

/** Fluent navigation pane: solid Mica-like surface separated by a hairline, no heavy shadow. */
const sidenav = {
  styleOverrides: {
    root: {
      width: pxToRem(288),
      whiteSpace: "nowrap",
      border: "none",
      zIndex: 1200,

      "&.MuiDrawer-paper": {
        position: "fixed" as const,
        top: 0,
        left: 0,
        width: pxToRem(288),
        height: "100vh",
        backgroundColor: background.sidenav,
        borderRight: `1px solid ${divider}`,
        boxShadow: "none",
        overflowY: "auto" as const,
        overflowX: "hidden" as const,
      },
    },

    docked: {
      transform: "translateX(0)",
      transition:
        "transform 0.2s cubic-bezier(0.33, 0, 0.67, 1), width 0.2s cubic-bezier(0.33, 0, 0.67, 1)",

      "&.MuiDrawer-docked .MuiDrawer-paper": {
        transform: "none",
      },
    },

    paper: {
      position: "fixed !important" as any,
      top: "0 !important",
      left: "0 !important",
      width: `${pxToRem(288)} !important`,
      height: "100vh !important",
      backgroundColor: `${background.sidenav} !important`,
      margin: "0 !important",
      borderRadius: "0 !important",
      borderRight: `1px solid ${divider} !important`,
      boxShadow: "none !important",
      overflowY: "auto" as const,
      overflowX: "hidden" as const,
      zIndex: 1200,
    },

    paperAnchorDockedLeft: {
      borderRight: `1px solid ${divider}`,
      boxShadow: boxShadows.none,
      position: "fixed" as const,
      height: "100vh",
      top: 0,
      left: 0,
    },
  },
};

export default sidenav;
